import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox, Stack, Typography } from '@mui/material';
export const BinaryControl = ({ state, dispatch, stateKey: key, label, maxWidth }) => {
    const { valueSettings } = state;
    if (!valueSettings[key]) {
        return _jsx(Typography, { children: `Can't find key ${key}` });
    }
    else
        return (_jsxs(Stack, { direction: 'row',
            alignItems: 'center',
            gap: 1,
            width: maxWidth,
            boxSizing: 'border-box',
            paddingInline: 1.5,
            borderRadius: 1,
            border: (t) => `1px solid ${t.palette.action.disabled}`,
            sx: {
                [`&:hover`]: {
                    border: (t) => `1px solid ${t.palette.action.active}`,
                },
            }, children: [_jsx(Checkbox, { checked: valueSettings[key].include,
                    sx: { padding: 0 },
                    onClick: () => {
                        dispatch({ type: 'TogglePresence', update: { key } });
                    } }), _jsx(Typography, { paddingBlock: 1, sx: { maxWidth }, children: label })] }));
};
